import { expVal } from '@atlassian/jira-feature-experiments';

const JiraSwTimelineHierarchyViewLevelFiltersRelayProvider = {
	get(): boolean {
		return expVal('jira_sw_timeline_hierarchy_view_level_filters', 'isEnabled', false);
	},
};

export default JiraSwTimelineHierarchyViewLevelFiltersRelayProvider;
